import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-survey-dialog',
  templateUrl: './survey-dialog.component.html',
  styleUrls: ['./survey-dialog.component.scss']
})
export class SurveyDialogComponent implements OnInit {
  @Input() dialogObj: any
  constructor() { }

  ngOnInit(): void {
  }

}
